/**
 * <Header
 *		// please describe props here
 *	/>
 *
 * This is...
 *
 * @parent anybody
 * @children
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import { connect } from 'react-redux';
import { MenuItem, Dropdown } from 'react-bootstrap'
import { getVersion } from 'root/version';
import { browserHistory } from 'react-router';
import SearchResult from 'containers/Main/SearchResult';
import { getSubscription } from '../ducks/subscription';
import { alert } from 'util/alert'

import __R, {userCan , isBasicUser, isValidUser, isOnlyTeacher} from 'containers/__R';
import locale from './locale';
import './Header.scss';

import CreateStudentModal from 'template/Modals/CreateStudent'
import CreateTeacherModal from 'template/Modals/CreateTeacher'
import CreateClassModal from 'template/Modals/CreateClass'
import CreateClassOneModal from 'template/Modals/CreateClassOne'
import CreateClassroomModal from 'template/Modals/CreateClassroom'
import AnnouncementModal from 'template/Modals/Announcement'
import PosterTypeModal from 'template/Modals/PosterType'
import PotentialClientModal from 'template/Modals/PotentialClient'
import AttendanceScanMessageModal from 'template/Modals/AttendanceScanMessage'
import CreateSchoolModal from 'template/Modals/CreateSchool'

import MediaCenterModal from 'template/Modals/MediaCenter'

import logo from 'data/images/logo_blue@2x.png';

const mapStateToProps = state => ({
  subscription: state.gSubscription,
  user: state.user
});

const mapDispatchToProps = dispatch => {
  return {
    getSubscription: (schoolId) => dispatch(getSubscription(schoolId)),
  };
}

class Header extends React.Component {
  constructor(props) {
    super(props);

    const currentLocale = localStorage.getItem('language');

    this.getVersionName = this.getVersionName.bind(this);
    this.changeLocale = this.changeLocale.bind(this);
    this.signOut = this.signOut.bind(this);

    this.state = {
      version: getVersion(currentLocale),
      searchText: '',
      currentLocale,
      showUpgradeMessage: true,
    }
  }

  componentWillMount(){
  }

  signOut() {
    localStorage.removeItem('token');
    localStorage.removeItem('schoolId');
    if(global['--subscription-refresher']){
      clearInterval(global['--subscription-refresher'])
    }
    window.location.href = '/';
  }

  getVersionName() {
    const {
      saas_version,
      days_left
    } = this.props.subscription.result;
   
    switch (saas_version) {
      case 0:
        return __('Free Trial ({daysLeft} days left)', locale, {daysLeft: days_left});
      case 1:
        return __('Discount Plan', 'settings'); 
      case 2:
      case 9:
      case 10:
      case 11:
      case 12:
        return __('Customized Plan', 'settings'); 
      case 3:
      case 4:
        return __('Basic Plan', 'settings');
      case 5:
      case 6:
        return __('Professional Plan', 'settings');
      case 7:
      case 8:
        return __('Premium Plan', 'settings');
      default: 
        return '';
      
    }
  }

  changeLocale(newCode) {
    return ()=>{
      localStorage.setItem('language', newCode);
      window.location.reload();
    }
  }
  createAnnouncementModal() {
    AnnouncementModal({allowEdit: 'true'})
  }
  renderLogDetail(log){
    return <div>{log.operator_type === 'teacher'? log.operator_name : 'principal'} {log.log_context.operation} {log.log_context.object_type} </div>
  }

  overLimitAlert(type){
    alert.message(__(`You are about go over the ${type} limit, please upgrade to higher subscription plan to add more ${type}s`, 'header'), __('Upgrade Subscription Plan', 'header'))
  }
  render() {
    const {
      currentLocale,
    } = this.state;

    const {
      schoolDetail,
      subscription,
      user,
      onSearchClear,
      onSearchChange,
      onSearchFocus,
      searchText,
      searchActive,
      getSubscription
    } = this.props;
    const {user_id, school_owned_amount} = user.result;
    const showSchoolInfo = typeof schoolDetail.id !== 'undefined';
    const showUerInfo = typeof user_id !== 'undefined';
    const role = localStorage.getItem('role');
    const schoolId = localStorage.getItem('schoolId')

    if(subscription.fetching){
      return( <div />)
    }

    return (
      <div className={classnames('Header', { 'Header__searchActive': searchActive })}>
        <div className='Header--left'>
          { showSchoolInfo &&
            <div className='Header--left--brand' onClick={()=>{ onSearchClear(); browserHistory.push('/student'); }}>
              <div className='Header--left--logoWrapper'>
                <img src={schoolDetail.logo} />
              </div>
              <div className='Header--left--schoolName'>{schoolDetail.title}</div>
            </div>
          }

          { showSchoolInfo &&
            <Dropdown className='Header--left--toggle' >
              <Dropdown.Toggle className='btn-link expand-to-left expand-to-down'>
                <i className='fa icon-down-open'></i>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <MenuItem eventKey="change-school" onSelect={()=>{ browserHistory.push('/') }}>
                  {__('Change School', locale)}
                </MenuItem>
                {
                  !(role == 'Teacher' || role == '老师' || role =='undefined') &&
                  <MenuItem eventKey="create-school" onSelect={()=>{
                    if(subscription.result.is_valid && (school_owned_amount<subscription.result.maximum_amount.maximum_school || subscription.result.saas_version === 1)){
                      CreateSchoolModal()
                    } else {
                      this.overLimitAlert('school')
                    }
                  }}>
                    {__('Create New School', locale)}  
                    {
                      subscription.result.saas_version === 1 &&
                      <small>{__('$79 USD / month per school', locale)}</small>
                    }
                  </MenuItem>
                }

              </Dropdown.Menu>
            </Dropdown>
          }

          <div className='Header--left--version'>
            {
              !showSchoolInfo &&
              <img src={logo} onClick={() => {browserHistory.push('/')}} style={{height: 18, marginRight: 16, marginTop: -5, cursor: 'pointer'}}/>
            }
            {
              isValidUser() && !(role == 'Teacher' || role == '老师' || role =='undefined') &&
              this.getVersionName()
            }
            {
              !isValidUser() && !isOnlyTeacher() && !(role == 'Teacher' || role == '老师' || role =='undefined') &&
              <span>{__('Need Subscription', locale)}</span>
            }
          </div>
          {
            !isOnlyTeacher() && (subscription.result.saas_version === 0 || !isValidUser()) && !(role == 'Teacher' || role == '老师' || role =='undefined') &&
            <a className='Header--left--upgradeButton' onClick={()=>browserHistory.push('/account-settings')}>
              {__('Subscribe', locale)}
            </a>
          }
        </div>

        { showSchoolInfo && false &&
        <div className='Header--search'>
          <input
            type='text'
            value={searchText}
            onChange={onSearchChange}
            onFocus={onSearchFocus}
            placeholder='Search...' />
          <i className='fa icon-search'></i>
          { searchText.length > 0 && <i className='fa icon-cancel' onClick={onSearchClear}></i> }
        </div>
        }

        <div className='Header--right'>
          <div className='Header--right--tools'>
            {/* { showSchoolInfo &&
              <Dropdown className='Header--right--notification'>
                <Dropdown.Toggle className='btn-link expand-to-right expand-to-down'>
                  <div className='bell-icon-wrapper'><div className='dot'></div><i className="fa icon-bell notification-icon"></i></div>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <div>Notification</div>
                  { !schoolLog.fetching &&
                      logs.result_list.map((log, key)=>{
                        if (key<30) {
                          return (
                            <div className='message-wrapper' key={key}>
                              <div className='message-title'>{log.operated_at}</div>
                              {this.renderLogDetail(log)}
                            </div>
                          )
                        }
                      })
                  }
                </Dropdown.Menu>
              </Dropdown>
            } */}
            {process.env.APP_ENV === 'development' && <button className='btn btn-primary' onClick={() => {
              MediaCenterModal({selectMultiple: true})
            }}>MEDIA CENTER</button>}

            { showSchoolInfo &&
            <Dropdown className='Header--right--create'>
              <Dropdown.Toggle className='btn-defult expand-to-right expand-to-down'>
                <i className='fa icon-plus'></i> {__('New', locale)}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <MenuItem
                  eventKey="create-student"
                  onSelect={()=>{
                    if(subscription.result.saas_version === 1 || subscription.result.maximum_amount.maximum_student === null || subscription.result.existing_amount.student_amount<subscription.result.maximum_amount.maximum_student){
                      CreateStudentModal({mode: 'create'})
                        .then((res)=>{
                          getSubscription(schoolId)
                        })
                    }else {
                      this.overLimitAlert('student')
                    }
                  }}
                  disabled={!userCan('create_student')}
                >
                  {__('Students', locale)}
                </MenuItem>
                <MenuItem eventKey="create-teacher" 
                  onSelect={()=>{ 
                    if(subscription.result.saas_version === 1 || subscription.result.maximum_amount.maximum_teacher===null || subscription.result.existing_amount.teacher_amount<subscription.result.maximum_amount.maximum_teacher){
                      CreateTeacherModal({mode: 'create'}) 
                        .then((res)=>{
                          getSubscription(schoolId)
                        })
                    }else {
                      this.overLimitAlert('teacher')
                    }
                  }} 
                  disabled={!userCan('create_teacher')}>
                  {__('Teachers', locale)}
                </MenuItem>
                <MenuItem eventKey="create-class" onSelect={()=>{ CreateClassModal({mode: 'create'}) }} disabled={!userCan('create_class')}>
                  {__('Classes', locale)}
                </MenuItem>
                <MenuItem eventKey="create-class" onSelect={()=>{ CreateClassOneModal({mode: 'create'}) }} disabled={!userCan('create_private_class')}>
                  {__('Private Classes', locale)}
                </MenuItem>
                <MenuItem eventKey="create-classroom" onSelect={()=>{ CreateClassroomModal({mode: 'create'}) }} disabled={!userCan('create_classroom')}>
                  {__('Classrooms', locale)}
                </MenuItem>
                <MenuItem eventKey="create-announcement" onSelect={()=>{ this.createAnnouncementModal() }} disabled={!userCan('create_announcement')}>
                  {__('Announcements', locale)}
                </MenuItem>
                <MenuItem eventKey="create-poster" onSelect={()=>{ PosterTypeModal() }} disabled={!userCan('create_poster') || isBasicUser()}>
                  {__('Posters', locale)}
                </MenuItem>
                <MenuItem eventKey="create-potentialStudent" onSelect={()=>{ PotentialClientModal() }} disabled={!userCan('create_contact')|| isBasicUser()}>
                  {__('Contacts', locale)}
                </MenuItem>
              </Dropdown.Menu>
            </Dropdown> }

            { showSchoolInfo &&
              <__R can='start_smart_check_in' by='disable' className='smart-check-in__R'>
                <button className='btn btn-default' disabled={isBasicUser()} onClick={()=>{
                  AttendanceScanMessageModal()
                }}>{__('Smart Check-in', locale)}</button>
              </__R>
            }

          { showUerInfo &&
            <Dropdown className='Header--right--account'>
              <Dropdown.Toggle className='btn-link expand-to-right expand-to-down'>
                <i className='fa icon-down-open'></i>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <div className='switchLanguages'>
                  { currentLocale !== 'EN' && <button className='btn btn-primary' onClick={this.changeLocale('EN')}>EN</button> }
                  { currentLocale !== 'CN' && <button className='btn btn-primary' onClick={this.changeLocale('CN')}>中文</button> }
                </div>
                <hr/>
                <MenuItem eventKey="privacy-policy" onSelect={()=>{ browserHistory.push('/privacy-' + currentLocale.toLowerCase()) }}>{__('Privacy Policy', locale)}</MenuItem>
                <MenuItem eventKey="account-settings" onSelect={()=>{ browserHistory.replace('/account-settings') }}>{__('Account Settings', locale)}</MenuItem>
                <MenuItem eventKey="logout" onSelect={this.signOut}>{__('Sign Out', locale)}</MenuItem>
              </Dropdown.Menu>
            </Dropdown>
          }
          </div>
        </div>

        { searchActive === true && <SearchResult searchText={searchText} /> }
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/containers/Main/Header/index.js